import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'

export const PROFILE_FIELDS = [
  'firstName',
  'fatherName',
  'lastName',
  'deviceTypeId',
  'deviceOwnership',
  'customerType',
  'whatsapp',
  'photo',
  'contract',
  'installedBy',
  'location',
] as const
export const PERSON_FIELDS = [
  'nationalId',
  'occupation',
  'education',
  'familyPhone',
  'installVillage',
  'installStreet',
  'installHouse',
] as const
export type FormFieldKey = (typeof PROFILE_FIELDS)[number] | (typeof PERSON_FIELDS)[number]

const settingsSchema = z.object({ requiredFields: z.array(z.string()) })

export async function fetchFormSettings(signal?: AbortSignal): Promise<string[]> {
  const response = await api.get<unknown>('/api/subscribers/form-settings', { ...(signal ? { signal } : {}) })
  return settingsSchema.parse(response.data).requiredFields
}

export async function saveFormSettings(requiredFields: string[]): Promise<string[]> {
  const response = await api.put<unknown>('/api/subscribers/form-settings', { requiredFields })
  return settingsSchema.parse(response.data).requiredFields
}

/** Tashkilot belgilagan majburiy maydonlar (ADR-052); yuklanguncha profilning hammasi majburiy. */
export function useRequiredFields(enabled = true): ReadonlySet<string> {
  const settings = useQuery({
    queryKey: queryKeys.subscribers.formSettings,
    queryFn: ({ signal }) => fetchFormSettings(signal),
    enabled,
    staleTime: 5 * 60_000,
  })
  return new Set(settings.data ?? PROFILE_FIELDS)
}
